import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { UserFunction, UserFunctionCheck, UserFunctionGuard, UserService } from '@stylehaven/components';
@Injectable({ providedIn: 'root' })
export class ViewOrganisationsGuard extends UserFunctionGuard {
    protected FUNCTIONS_TO_CHECK: UserFunction[] = [
        UserFunction.readOrganisations,
        UserFunction.adminViewAllOrganisations
    ];
    protected USER_FUNCTION_CHECK: UserFunctionCheck = UserFunctionCheck.HasAny;

    constructor(
        protected userService: UserService,
        protected router: Router
    ) {
        super(userService, router);
    }
}
